"use client";

import { useTheme } from "../context/ThemeContext";
import dynamic from "next/dynamic";
import {
  TOP_LOADER_MARKETING_DARK,
  TOP_LOADER_MARKETING_LIGHT,
} from "@/src/constants/app-programmatic-theme";

const NextTopLoader = dynamic(() => import("nextjs-toploader"), { ssr: false });

export const UsersDashboardTopLoader = () => {
  const { theme } = useTheme();

  return (
    <NextTopLoader
      color={
        theme === "dark" ? TOP_LOADER_MARKETING_DARK : TOP_LOADER_MARKETING_LIGHT
      }
    />
  );
};
